const conventionSignupStubByPageSlug: Record<string, string> = {
  'the-session': 'the-session-2027',
  'magifest': 'magifest-2027',
  'the-retreat-mexico-2025': 'the-retreat-mexico-2025',
  'the-retreat-greece-2026': 'the-retreat-greece-2026',
  'the-retreat-hawaii-2026': 'the-retreat-hawaii-2026',
  'the-retreat-machu-picchu-2027': 'the-retreat-machu-picchu-2027',
  'the-retreat-scotland-2027': 'the-retreat-scotland-2027',
}

export const getConventionSignupStub = (conventionPageSlug: string): string => {
  return conventionSignupStubByPageSlug[conventionPageSlug] ?? conventionPageSlug
}

export const getConventionRegisterPath = (conventionPageSlug: string): string => {
  return `/magic-conventions/${getConventionSignupStub(conventionPageSlug)}/register/`
}
